import { createApi } from "@reduxjs/toolkit/query/react";
import { defaultBaseQuery } from "../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";
import { transformRequest } from "../../utils/API/requestMiddleware";

const xmlReportAPI = createApi({
    reducerPath: 'xmlReportAPI',
    baseQuery: defaultBaseQuery,
    endpoints: (builder) => ({

        addXMLReport: builder.mutation({
            query: (data) => ({
                url: `/XMLReport/AddXMLReport`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updateXMLReport: builder.mutation({
            query: (data) => ({
                url: `/XMLReport/UpdateXMLReport`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getXMLReportList: builder.mutation({
            query: (data) => ({
                url: `/XMLReport/GetXMLReport`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAllXmlTemplateList: builder.query({
            query: () => ({
                url: `/XMLReport/GetAllXmlTemplate`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
      
        UpdateXMLTemplateToggle: builder.mutation({
            query: (data) => ({
                url: `/XMLReport/UpdateXMLTemplateToggle`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updateXmlSchemaAssign: builder.mutation({
            query: (data) => ({
                url: `/XMLReport/UpdateXmlSchemaAssign`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    })
})
export const {
    useAddXMLReportMutation,
    useUpdateXMLReportMutation,
    useGetXMLReportListMutation,
    useLazyGetAllXmlTemplateListQuery,
    useUpdateXMLTemplateToggleMutation,
    useUpdateXmlSchemaAssignMutation
} = xmlReportAPI;

export default xmlReportAPI;